import React from 'react';
import SurveyContainer from '../../Card/VirtualEvent/Containers/Survey/NewSessionSurvey.container';

const NewSessionSurvey = (props) => <SurveyContainer id="tc_survey_modal1" {...props} />;

export default NewSessionSurvey;
